module.exports = "/assets/5dbe33aec29ddbc2b3ef1ff0f769ac5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/QG.png
// module id = 2873
// module chunks = 0